<template>
    <div id="app-header" class="app-header navbar">
        <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
            <FontAwesomeIcon icon="fas fa-bars" />
        </button>
        <router-link class="navbar-brand d-none d-sm-none d-md-none d-lg-block" :to="{ name: 'home' }">
            <img v-if="bannerLogoUrl" :src="bannerLogoUrl" :style="{ 'height': '80%' }" />
            <span v-else class="navbar-brand-content"></span>
        </router-link>
        <button class="navbar-toggler sidebar-toggler d-md-down-none bars-icon" type="button" @click="sidebarMinimize">
            <FontAwesomeIcon icon="fas fa-bars" />
        </button>
        <ul class="navbar-nav utility-nav ms-auto me-1">
            <li 
            v-if="walkMeEnabled"
            class="nav-item nav-icon-item">
                <b-dropdown class="nav-link" role="menu" no-caret large right >
                    <template #button-content>
                        <span class="nav-icon">
                            <FontAwesomeIcon icon="far fa-circle-question" @click="onHelpClick"/>
                        </span>
                    </template>
                </b-dropdown>
            </li>
            <li class="nav-item nav-icon-item">
                <b-dropdown class="nav-link" role="menu" no-caret large right>
                    <template #button-content>
                        <span class="nav-icon">
                            <FontAwesomeIcon icon="far fa-user" />
                        </span>
                    </template>
                    <!-- <user-avatar ref="Avatar" :uniqueId="uniqueId" /> -->
                    <b-dropdown-item @click="showProfileInfo"><FontAwesomeIcon icon="fas fa-cog" /> Profile</b-dropdown-item>
                    <b-dropdown-item @click="showSystemInfo"><FontAwesomeIcon icon="fas fa-desktop" /> System</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="onSignOut"><FontAwesomeIcon icon="fas fa-sign-out-alt" /> Sign out</b-dropdown-item>
                </b-dropdown>
            </li>

            <li v-if="isAuthenticated" class="navbar-text nav-session-user">{{sessionUserName}}</li>
        </ul>
        <!-- <b-navbar-nav id="profile-icon" class="utility-nav ms-auto me-1">
            <help-nav-item class="nav-icon-item walk-me-item" />
            <b-nav-item-dropdown class="nav-icon-item" role="menu" :no-caret="true" large right offset="12">
                <user-avatar ref="Avatar" :uniqueId="uniqueId" />
                <b-dropdown-item @click="showProfileInfo">Profile</b-dropdown-item>
                <b-dropdown-item @click="showSystemInfo">System</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="logoff">Sign out</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-text class="nav-session-user">{{sessionUserName}}</b-nav-text>
        </b-navbar-nav> -->
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { AUTH_ACTIONS } from "@/store/actions";
import { GlobalEventManager, GLOBAL_EVENTS } from "@/app.events";
import ProfileEdit from "@/modules/titlecompany/ProfileEdit";
import SystemInfo from '@/modules/titlecompany/SystemInfo';
// import UserAvatar from '@/components/UserAvatar';
// import HelpNavItem from './HelpNavItem';
const isNewFileProcessing = 'tc:isNewFileProcessing';

export default {
    name: 'AppHeader',
    data: function() {
        return {
        }
    },
    components: {
    },
    computed: {
        ...mapGetters(["user", "site", "isAuthenticated"]),
        bannerLogoUrl() {
            return _.get(this, "site.bannerLogoUrl", null) || '/r2c-logo.png';
        },
        sessionUserName() {
            return this.user.displayName;
        },
        dashboardNotificationEnabled() {
            let workflowDashboardIndicator = this.getUserPropertyValue("workflowDashboardIndicator");
            return _.gt(_.parseNumber(workflowDashboardIndicator, 0), 0);
        },
        uniqueId() {
            return this.user.uniqueId;
        },
        userAccountId() {
            return this.user.userAccountId;
        },
        isNewFileProcessing() {
            return _.parseBool(localStorage.getItem(isNewFileProcessing), false);
        },
        walkMeEnabled() { return _.getBool(appSettings, "showWalkMe") && !this.isMobile },
    },
    methods: {
        mobileSidebarToggle(e) {
            e.preventDefault();
            this.toggleClass("sidebar-mobile-show");
        },
        sidebarMinimize(e) {
            e.preventDefault();
            this.toggleClass("sidebar-minimized", "sidebar::toggleMinimized");
            this.sidebarMinimized = this.toggleClass("brand-minimized");
        },
        toggleClass(className, eventName=null) {
            document.body.classList.toggle(className);
            if(!eventName) return;
            let value = document.body.classList.contains(className);
            this.$events.emit(eventName, { value });
            return value;
        },
        getUserPropertyValue(property) {
            let val = _.get(this, `currentSession.user.${property}`, null);
            if(_.isString(val)) return _.trim(val);
            return val;
        },
        onHelpClick() {
            if(typeof WalkMePlayerAPI === "undefined" || window?.WalkMePlayerAPI?.isMenuOpen?.()) return;
            window.WalkMePlayerAPI?.toggleMenu?.();
        },
        onSignOut() {
            GlobalEventManager.busyEnd();
            this.$store.dispatch(AUTH_ACTIONS.LOGOUT, { redirectUrl: window.location.origin });
            // this.$keycloak.logoutFn();
        },
        showSystemInfo() {
            const self = this;
            let onOk = (e) => {
                self.$dialog.close();
            };
            self.$dialog.open({
                title: "System",
                height: "420",
                width: "500",
                adaptive: false,
                hideHeaderClose: true,
                closeOnEsc: true,
                component: SystemInfo,
                okOnly: true,
                props: {
                },
                buttons: [
                    { title: "Close", automationId: "btn_dm_modal_ok", cssClass: "btn btn-primary", closeOnComplete: false, onClick:  (e) => { onOk(e, false); } }
                ],
            });
        },
        showProfileInfo() {
            const self = this;
            let onOk = (e) => {
                e.component.validate();
                if (!e.component.isValid) return false;
                e.component.modalSave()
                .then((e) => {
                    self.$dialog.close();
                    return true;
                })
                .catch((err) => {
                    return false;
                });
            };
            let onCancel = e => {
                self.$dialog.close();
                self.$emit('Close');
            };
            self.$dialog.open({
                title: `${self.uniqueId ? "Add" : "Edit"} My Profile`,
                height: "620",
                width: "400",
                adaptive: false,
                hideHeaderClose: true,
                closeOnEsc: true,
                component: ProfileEdit,
                props: {
                    uniqueId: self.uniqueId
                },
                buttons: [
                    { title: "Cancel", automationId: "btn_dm_modal_cancel", cssClass: "btn btn-secondary", closeOnComplete: false, onClick: onCancel },
                    { title: "Ok", automationId: "btn_dm_modal_ok", cssClass: "btn btn-primary", closeOnComplete: false, onClick: onOk }
                ],
            });
        },
    },
}
</script>
<style lang="scss">
    .brand-minimized {
        & .navbar-brand {
            text-align: center;
        }
    }

    #profile-icon {
        & .dropdown {
            // padding: 5px;

            &.show  {
                & .no-image {
                    background: none;
                    // opacity: 1;
                }
            }
        }
        & .dropdown-toggle {
            padding-top: 6px;
            height: 26px;
            width: 26px;
            // background: transparent;
        }
        & .rq-avatar {
            height: 100%;
            width: 100%;
            border: none;

            & img {
                height: 26px;
                width: 26px;
            }

            & .no-image {
                background: transparent;
            }

            & .image-icon--default {
                width: 26px;
                height: 26px;
                color: unset;
            }
        }
    }
</style>